module.exports = __webpack_public_path__ + "img/apple-icon-120x120.2ce721f5.png";